import http, { API_CORE } from '../http';

export default function CustomizeHomepageService() {
  const create = async (payload) => {
    try {
      const response = await http(API_CORE).post('/customize-homepage', {
        payload,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create homepage configuration');
    }
  };

  const get = async () => {
    try {
      const response = await http(API_CORE).get('/customize-homepage');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get homepage configuration');
    }
  };

  const deleteSection = async (sectionId) => {
    try {
      const response = await http(API_CORE).delete(`/customize-homepage/${sectionId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to delete homepage section');
    }
  };

  const sortSections = async (sectionIds) => {
    try {
      const response = await http(API_CORE).put('/customize-homepage/sort', {
        sectionIds,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to reorder homepage sections');
    }
  };

  const updateSectionActiveState = async (sectionId, isActive) => {
    try {
      const response = await http(API_CORE).put(`/customize-homepage/${sectionId}/active`, {
        isActive,
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.error || 'Failed to update homepage section active state'
      );
    }
  };

  const updateSection = async (sectionId, payload) => {
    try {
      const response = await http(API_CORE).put(`/customize-homepage/${sectionId}`, { payload });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to update homepage section');
    }
  };

  return {
    create,
    get,
    deleteSection,
    sortSections,
    updateSectionActiveState,
    updateSection,
  };
}
